import * as Sentry from '@sentry/react';

import { SentryInitProps } from './sentry-util.types';

const DEFAULT_SENTRY_ENVIRONMENTS = ['qa', 'staging', 'production'];

/**
 * Initializes Sentry with the provided configuration.
 * Sentry will only be initialized if a valid DSN is provided and the current environment is allowed.
 * @param props - The properties for initializing Sentry, including DSN, environment, and allowed environments.
 */
export function initSentry({
  dsn,
  environment,
  allowedEnvironments = DEFAULT_SENTRY_ENVIRONMENTS,
  ...props
}: SentryInitProps) {
  const shouldInit = dsn && allowedEnvironments.includes(environment);
  if (!shouldInit) return;
  Sentry.init({
    ...props,
    dsn,
    environment,
    debug: environment !== 'production',
    enableLogs: true,
  });
}
